import userApi from '@/api/user'
import axios from 'axios'
import i18n from '@/i18n'

import numeral from 'numeral'
import 'numeral/locales/ja'
import { Auth } from 'aws-amplify'
numeral.locale('ja')

const TOKEN_KEY = 'vs-token'

const state = {
  userInfo: {},
  stores: [],
  currentStore: {}
}

// getters
const getters = {
  getUserInfo: state => {
    return state.userInfo
  },
  getStores: state => state.stores,
  getCurrentStore: state => state.currentStore,
  getCurrentStoreKey: state => {
    // todo: this is temporary function, because there is no store key in the return of api
    // change space to under score
    // change string to lowercase
    if (!state.currentStore || !state.currentStore.name) {
      return
    }
    return state.currentStore.name.toLowerCase().replace(/ /g, '_')
  }
}

// actions
const actions = {
  async authCheck ({ dispatch, state }) {
    try {
      const currentSession = await Auth.currentSession()
      if (!state.userInfo || !state.userInfo.email) { // no init
        await dispatch('setTokenAndUserInfo', currentSession)
      }
      return state.userInfo
    } catch (e) {
      return null
    }
  },
  async signIn ({ dispatch }, payload) {
    const { email, password } = payload
    const response = await Auth.signIn(email, password)
    const token = response.signInUserSession.idToken.jwtToken
    localStorage.setItem(TOKEN_KEY, token)
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return dispatch('getUserInfoAndStores')
  },
  signOut ({ commit }) {
    Auth.signOut()
    commit('resetUserAndStores')
  },
  async getUserInfoAndStores ({ commit, dispatch }) {
    const userInfoResponse = await userApi.getUserInfo()
    const userInfo = userInfoResponse.user
    const stores = userInfoResponse.stores
    if (!stores || stores.length === 0) {
      throw new Error('no store')
    }
    commit('setUser', userInfo)
    commit('setStores', stores)
    // // reset chart data
    dispatch('charts/resetAllCharts', null, { root: true })
    commit('usage/resetModule', null, { root: true })
    commit('datalink/resetModule', null, { root: true })

    // // set state
    dispatch('setCurrentStore', stores[0])
  },
  // when service has up, will be run one time.
  // if there is stored token, get store and user info
  // and if it has not succeed, clear that token
  async setTokenAndUserInfo ({ dispatch, commit }, currentSession) {
    const token = currentSession.idToken.jwtToken
    localStorage.setItem(TOKEN_KEY, token)
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    try {
      await dispatch('getUserInfoAndStores')
    } catch (e) {
      commit('resetUserAndStores')
    }
  },
  setCurrentStore ({ dispatch, commit }, store) {
    commit('setCurrentStore', store)
    dispatch('charts/resetAllCharts', null, { root: true })
    dispatch('usage/fetchAllUsage', null, { root: true })
    dispatch('datalink/refetchHistory', null, { root: true })
  }
}

// mutations
const mutations = {
  setUser (state, user) {
    state.userInfo = user
  },
  setStores (state, stores) {
    state.stores = stores
  },
  setCurrentStore (state, store) {
    switch (store.region) {
      case 'ko':
        i18n.locale = 'kr'
        break
      case 'ja':
        i18n.locale = 'jp'
        break
      case 'se':
        i18n.locale = 'se'
        break
      default:
        i18n.locale = 'en'
    }
    state.currentStore = store
  },
  resetUserAndStores (state) {
    localStorage.removeItem(TOKEN_KEY)
    axios.defaults.headers.common['Authorization'] = null
    state.userInfo = {}
    state.stores = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
